import { DomainStoreType } from '@vista-digital/occ-domain'
import { createDomainStore } from '@vista-digital/occ-domain/src/lib/storage/create-domain-store'
import type { Popup } from '../models/popup.types'

interface PopupPersistentDomainStore {
    viewed: Record<Popup['id'], Date>
}

interface PopupSessionDomainStore {
    viewed: Array<Popup['id']>
}

export const popupPersistentDomain = createDomainStore<PopupPersistentDomainStore>({
    type: DomainStoreType.BrowserLocal,
    defaultState: { viewed: {} },
    name: 'popup-persistent-domain-store',
})

export const popupSessionDomain = createDomainStore<PopupSessionDomainStore>({
    type: DomainStoreType.BrowserSession,
    defaultState: { viewed: [] },
    name: 'popup-session-domain-store',
})
